import React from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider, CssBaseline } from '@mui/material';
import SnackbarNotify from 'shared/snackbar/Notify';
// defaultTheme
import theme from 'theme';
import { FeatureFlagProvider } from 'context/featureFlagContext';
import { ManagementProvider } from 'context/managementContext';
import { SubscriptionProvider } from 'context/subscriptionContext';
import RouterWrapper from 'routes/RouterWrapper';

function App() {
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<ManagementProvider>
					<FeatureFlagProvider>
						<SubscriptionProvider>
							<CssBaseline />
							<SnackbarNotify />
							<RouterWrapper />
						</SubscriptionProvider>
					</FeatureFlagProvider>
				</ManagementProvider>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}

export default App;
